<template>
  <v-app
    v-if="i18nLoaded"
    :class="[
      getKeyboardOpen ? classes + ' keyboard-open' : classes,
      { 'platform-ios': platformIos }
    ]"
  >
    <!-- <NewsBannerSlider v-if="isAuthenticated" /> -->
    <Navbar
      :key="key"
      :primaryLinks="primaryLinks"
      :infoLinks="infoLinks"
      :applicationConfig="applicationConfig"
    />
    <v-navigation-drawer
      v-model="drawerLeft"
      touchless
      left
      app
      clipped
      temporary
      width="360"
      class="categories"
    >
      <CategoryTree
        :infoLinks="infoLinks"
        :primaryLinks="primaryLinks"
        @close="drawerLeft = false"
      />
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="drawerRight"
      disable-resize-watcher
      touchless
      temporary
      clipped
      right
      app
      width="600"
      id="cart-right-drawer"
      class="cart-drawer white"
    >
      <div class="cart-info" v-if="drawerRight">
        <CartInfoCompact :isCart="true" class="infos" />
        <CartItemList
          class="items-list"
          :full="$vuetify.breakpoint.xs"
          :checkMobile="iosMobile"
          :showCartButton="false"
        />
        <CartSummary
          class="summary py-0"
          :class="{ 'cart-item-list-no-checkout-osx': iosMobile }"
        />
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer
      class="links-list white"
      v-if="cordovaPlatform"
      v-model="drawerLinks"
      touchless
      right
      clipped
      app
      width="360"
      @close="drawerLinks = false"
    >
      <MenuLinksList :links="footerLinks" @close="drawerLinks = false" />
    </v-navigation-drawer>
    <v-main>
      <ebsn-style
        :target="applicationConfig"
        path="category_advanced.CSS_STYLE"
      />
      <div class="content-wrap">
        <v-skeleton-loader
          type="actions, image, article,image"
          v-if="loading"
          :loading="loading"
        ></v-skeleton-loader>
        <router-view v-else></router-view>
      </div>
      <category-block
        v-if="applicationConfig"
        :target="applicationConfig"
        position="tutorial"
        class="category-block category-block-tutorial"
      />
      <Footer :links="footerLinks" :applicationConfig="applicationConfig" />
    </v-main>

    <ScrollTop />
    <SsoUserCard />
    <!-- <GiftCertificateWindow /> -->
  </v-app>
</template>
<style lang="scss">
.cart-info {
  .infos {
    background-color: var(--v-grey-lighten2) !important;
    height: #{$cart-info-height};
  }
  .summary {
    position: fixed;
    bottom: 0;
    width: 100%;

    height: #{$summary-height};
    background-color: var(--v-grey-lighten2);
    border-top: 8px solid var(--v-secondary-base);
  }
  .items-list {
    $background: white;
  }
  .cart-item-list {
    height: calc(100vh - 258px);
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    height: auto;
    .items-list {
      background: transparent;
    }
    .infos {
      height: auto;
      box-shadow: 0px 3px 6px #00000029 !important;
    }
    .summary {
      box-shadow: 0px -3px 6px #00000029 !important;
    }
    .cart-item-list-no-checkout-osx {
      padding-bottom: $summary-height-osx !important;
    }
  }
}
</style>
<script>
// import VueInstagram from "vue-instagram";
import CartSummary from "@/components/cart/CartSummary.vue";
import CartInfoCompact from "@/components/cart/CartInfoCompact.vue";
import CartItemList from "@/components/cart/CartItemList.vue";
import CategoryTree from "@/components/navigation/CategoryTree.vue";
import CheckDisclaimerDialog from "@/components/profile/CheckDisclaimerDialog.vue";
import SsoUserCard from "@/components/profile/SsoUserCard.vue";

import login from "~/mixins/login";
import version from "~/mixins/version";

import CmService from "~/service/cmService";
import UserService from "~/service/userService";
import CategoryService from "~/service/categoryService";

import { mapActions, mapGetters } from "vuex";
import findIndex from "lodash/findIndex";
import { setLocale } from "@/plugins/i18n";

import ScrollTop from "./components/ScrollTop.vue";
import analyticsService from "./commons/service/analyticsService";
import MenuLinksList from "@/components/navigation/MenuLinksList.vue";

//TEST
// import testMenuData from "/public/json/testMenuLinks.json";
//TEST

export default {
  name: "App",
  components: {
    // VueInstagram,
    CategoryTree,

    CartInfoCompact,
    CartSummary,
    CartItemList,
    // NewsBannerSlider,
    // CategoryBlock,
    Footer: () =>
      process.env.CORDOVA_PLATFORM
        ? import("@/components/navigation/BottomNavBar.vue")
        : import("@/components/navigation/Footer.vue"),
    Navbar: () =>
      process.env.CORDOVA_PLATFORM
        ? import("@/components/navigation/NavbarMobile.vue")
        : import("@/components/navigation/Navbar.vue"),
    SsoUserCard,
    ScrollTop,
    MenuLinksList
    // ,
    // GiftCertificateWindow
  },
  mixins: [login, version],
  data() {
    return {
      load404: false,
      initialHref: window.location.href,
      loading: true,
      primaryLinks: [],
      infoLinks: [],
      categoryTreeLinks: [],
      footerLinks: [],
      applicationConfig: null,
      i18nLoaded: false,
      key: 1,
      classes: process.env.CORDOVA_PLATFORM ? "is-cordova" : "",
      platformIos: false,
      keyboardOpen: false,
      iosMobile: false,
      attValue: false
    };
  },
  metaInfo: {
    title: "Zona",
    titleTemplate: "%s - Zona",
    meta: [
      { charset: "utf-8" },
      {
        vmid: "description",
        name: "description",
        content:
          "Scopri Zona Spesa Online. Vendita all'ingrosso di alimentari, bevande, attrezzature professionali e forniture per negozi, bar, ristoranti ed hotel. Scegli tra spedizione o ritiro."
      },
      {
        vmid: "viewport",
        name: "viewport",
        content: "width=device-width, user-scalable=no"
      },
      { vmid: "author", name: "author", content: "Digitelematica s.r.l." },
      // Open Graph Metas
      { vmid: "og:locale", property: "og:locale", content: "it_IT" },
      { vmid: "og:title", property: "og:title", content: "%s - Zona" },
      {
        vmid: "og:description",
        name: "og:description",
        content:
          "Scopri Zona Spesa Online. Vendita all'ingrosso di alimentari, bevande, attrezzature professionali e forniture per negozi, bar, ristoranti ed hotel. Scegli tra spedizione o ritiro."
      },
      { vmid: "og:type", property: "og:type", content: "website" },
      { vmid: "og:url", property: "og:url", content: location.href },
      {
        vmid: "og:image",
        property: "og:image",
        content:
          window.location.host + global.config.socialLogo ||
          "/logo/social-logo.png"
      },
      {
        vmid: "og:image:alt",
        property: "og:image:alt",
        content:
          "Scopri Zona Spesa Online. Vendita all'ingrosso di alimentari, bevande, attrezzature professionali e forniture per negozi, bar, ristoranti ed hotel. Scegli tra spedizione o ritiro."
      },
      {
        vmid: "og:site_name",
        property: "og:site_name",
        content: "Zona"
      },
      // Twitter Metas
      {
        vmid: "twitter:card",
        name: "twitter:card",
        content: "summary_large_image"
      },
      {
        vmid: "twitter:title",
        name: "twitter:title",
        content: "%s - Zona"
      },
      {
        vmid: "twitter:image",
        name: "twitter:image",
        content:
          window.location.host + global.config.socialLogo ||
          "/logo/social-logo.png"
      },
      {
        vmid: "twitter:url",
        name: "twitter:url",
        content: location.href
      }
    ]
  },
  computed: {
    ...mapGetters({
      needRestart: "needRestart",
      isAuthenticated: "cart/isAuthenticated"
    }),
    drawerLeft: {
      get() {
        return this.$store.state.app.drawerLeft;
      },
      set(value) {
        this.$store.commit("app/updatedDrawerLeft", value);
      }
    },
    drawerRight: {
      get() {
        return this.$store.state.app.drawerRight;
      },
      set(value) {
        this.$store.commit("app/updatedDrawerRight", value);
      }
    },
    drawerLinks: {
      get() {
        return this.$store.state.app.drawerLinks;
      },
      set(value) {
        this.$store.commit("app/updatedDrawerLinks", value);
      }
    },
    getUserId() {
      return this.$store.state.cart.cart.user
        ? this.$store.state.cart.cart.user.userId
        : undefined;
    },
    getKeyboardOpen: function() {
      return this.keyboardOpen;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  },
  methods: {
    ...mapActions({
      updateAuth: "cart/updateAuth",
      resetFilters: "category/resetFilters",
      updateLastStartTime: "app/updateLastStartTime",
      updateFingerprint: "app/updateFingerprint"
    }),

    checkOsx() {
      var userAgent = [];
      var version = [];
      var versionNumber = 0;
      if (navigator.userAgent.indexOf("iPhone") > -1) {
        userAgent = navigator.userAgent.split(" ");
        userAgent.filter(ua => {
          if (ua.indexOf("Version/") > -1) {
            version = ua.split("/");
          }
        });
        versionNumber = parseFloat(version[1]);
        if (version[0] == "Version") {
          if (versionNumber < 15) {
            this.iosMobile = true;
          } else {
            this.iosMobile = false;
          }
        } else {
          this.iosMobile = false;
        }
      }
    },
    fetchInfoLinks() {
      //TODO: verificare se va scaricata una voce da WP
      this.infoLinks = [
        {
          classes: "lavoraConNoi",
          url: "/lavora-con-noi",
          title: "Lavora con noi"
        },
        {
          classes: "parlaConNoi",
          url: "/parla-con-noi",
          title: "Parla con noi"
        }
      ];
    },
    fetchPrimaryLinks() {
      CmService.getMenuByLocation("primary").then(
        data => (this.primaryLinks = data)
      );

      // this.primaryLinks = testMenuData;
    },
    fetchFooterLinks() {
      CmService.getMenuByLocation("footer").then(
        data => (this.footerLinks = data)
      );
    },
    async fetchApplicationConfig() {
      try {
        let result = await CategoryService.getCategoryBySlug("application");
        this.applicationConfig = result;
        if (result.templateNavItems) {
          this.primaryLinks = result.templateNavItems.Header;
          this.footerLinks = result.templateNavItems.Footer;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async onResume() {
      var _this = this;
      var hash;
      global.EventBus.$emit("resume");
      setTimeout(async function() {
        hash = findIndex(global.config.hashNotReload, function(o) {
          return window.location.hash.indexOf(o) !== -1;
        });
        var needRestart =
          new Date().getTime() - _this.$store.state.app.lastStartTime >
          global.config.reloadAfterMillis;
        if (hash === -1 && needRestart) {
          global.EventBus.$emit("restart");
        } else {
          if (
            hash === -1 &&
            window.sessionStorage.getItem("is-authenticated")
          ) {
            await _this.loadCart();
          }
          global.EventBus.$emit("reload");
        }
      }, 100);
    },
    async handleLogin() {
      this.doLogin("response419");
    },
    async onDeepLinks(path, queryString) {
      var _this = this;
      var currentQuery = {};
      console.log("onDeepLinks :::: ", path);
      console.log("onDeepLinks queryString :::: ", queryString);
      console.log("_this.$router :::: ", _this.$router);
      setTimeout(async function() {
        if (queryString) {
          currentQuery.q = queryString.replace("q=", "").replace(/%20/g, " ");
          console.log("onDeepLinks currentQuery :::: ", currentQuery);
          _this.$router.push({
            path: "/search",
            name: "Search",
            query: currentQuery
          });
        } else {
          _this.$router.push(path);
        }
      }, 100);
    },
    resolveRoute(data) {
      var _this = this;
      var currentQuery = {};
      console.log("resolveRoute :::: ", data);
      if (global.config.domainWhitelist.includes(data.host)) {
        let queryString = data.queryString;
        let resolved = this.$router.resolve({
          path: data.path
        });
        if (
          resolved &&
          resolved.route.matched.length > 0 &&
          resolved.route.name != "DefaultRoute"
        ) {
          setTimeout(async function() {
            if (queryString) {
              var keyValPairs = queryString.split("&");
              for (var pairNum in keyValPairs) {
                var key = keyValPairs[pairNum].split("=")[0];
                if (key.length > 0) {
                  if (typeof currentQuery[key] === "undefined")
                    currentQuery[key] = "";
                  currentQuery[key] = keyValPairs[pairNum].split("=")[1];
                }
              }
              currentQuery.q = queryString
                .replace("q=", "")
                .replace(/%20/g, " ");
              console.log("onDeepLinks currentQuery :::: ", currentQuery);
              _this.$router.push({
                path: data.path,
                query: currentQuery
              });
            } else {
              _this.$router.push(data.path);
            }
          }, 100);
        } else {
          if (this.$platform_is_cordova && data.url.indexOf("http") > -1) {
            //if app open on _system browser
            window.cordova.InAppBrowser.open(data.url, "_system");
          }
        }
      } else {
        if (this.$platform_is_cordova && data.url.indexOf("http") > -1) {
          //if app open on _system browser
          window.cordova.InAppBrowser.open(data.url, "_system");
        }
      }
    },
    onAppTrackingTransparency() {
      var _this = this;
      // eslint-disable-next-line no-undef
      let platform = device ? device.platform.toLowerCase() : "ios";
      if (
        _this.$platform_is_cordova &&
        platform == "ios" &&
        window.plugins.impacTracking
      ) {
        console.log("Calling onAppTrackingTransparency");
        window.plugins.impacTracking.trackingAvailable(
          function(available) {
            if (!available) {
              console.log(
                "Tracciamento non disponibile o disabilitato dall'utente"
              );
              window.plugins.impacTracking.canRequestTracking(
                function(result) {
                  // Show results in the console
                  console.log(result);
                  if (result == true) {
                    // eslint-disable-next-line no-undef
                    Cookiebot.hide();
                    window.plugins.impacTracking.requestTracking(
                      undefined,
                      function(res) {
                        console.log(res);
                        _this.attValue = res;
                        if (res == true) {
                          // eslint-disable-next-line no-undef
                          Cookiebot.submitCustomConsent(true, true, true);
                        }
                        if (res == false) {
                          // eslint-disable-next-line no-undef
                          Cookiebot.hide();
                        }
                      },
                      function(err) {
                        console.log(err);
                        //TODO: tracking non abilitato
                      }
                    );
                  }
                },
                function(err) {
                  console.log(err);
                  //TODO: c'è stato un errore: tracking non abilitato
                }
              );
            } else {
              window.plugins.impacTracking.requestTracking(
                undefined,
                function(res) {
                  console.log(
                    "Calling onAppTrackingTransparency; already defined"
                  );
                  console.log("AppTracking enabled: " + res);
                  _this.attValue = res;
                  // eslint-disable-next-line no-undef
                  var stats = Cookiebot.consent.statistics;
                  // eslint-disable-next-line no-undef
                  var mrkg = Cookiebot.consent.marketing;
                  // eslint-disable-next-line no-undef
                  var pref = Cookiebot.consent.preferences;
                  // eslint-disable-next-line no-undef
                  Cookiebot.submitCustomConsent(pref, stats, mrkg);
                  if (res == false) {
                    // eslint-disable-next-line no-undef
                    Cookiebot.hide();
                  }
                },
                function(err) {
                  console.log(err);
                }
              );
            }
          },
          function(err) {
            console.log(err);
          }
        );
      }
    },
    async refreshLogin() {
      if (global.config.pushNotificationEnabled) {
        console.log("REFRESH LOGIN - REGISTER FIREBASE DEVICE");
        // Al Deviceready facciamo un refresh login per controllare se l'utente è ancora collegato
        // await SecurityService.refreshLogin();
        // await this.registerFirebaseDevice();
      }
    },
    ...mapActions({
      loadCart: "cart/loadCart"
    }),
    isPlatformIos() {
      if (this.isCordova && window.cordova.platformId.toLowerCase() === "ios") {
        this.platformIos = true;
      }
    },
    async checkMissingDisclaimer() {
      let response = await UserService.checkUserDisclaimer(2);
      if (
        response &&
        response.registrationModules &&
        response.registrationModules.length > 0
      ) {
        await this.openDialog(CheckDisclaimerDialog, {
          waitForResult: true,
          fullscreen: false
        });
      }
    }
  },
  async created() {
    await setLocale("it"); //abilitare se si vuole usare la risorsa di localizzazione remota
    this.i18nLoaded = true;
    var _this = this;
    _this.load404 = false;
    // await this.fetchPrimaryLinks();
    await this.fetchInfoLinks();
    // await this.fetchFooterLinks();
    this.fetchApplicationConfig();
    try {
      if (
        window.sessionStorage.getItem("is-authenticated") ||
        window.sessionStorage.getItem("X-Ebsn-Session") ||
        window.localStorage.getItem("X-Ebsn-Account")
      ) {
        await _this.loadCart();
      } else {
        analyticsService.initCustomDimension();
      }
    } finally {
      _this.loading = false;
    }
    //generate fingerprint
    // const fp = await FingerprintJS.load({ monitoring: false });
    // this.updateFingerprint(await fp.get());

    global.EventBus.$on("isNotLoggedIn", () => {
      _this.updateAuth();
      _this.handleLogin();
    });
    global.EventBus.$on("restart", () => {
      _this.updateLastStartTime();
      window.location.reload();
    });
    global.EventBus.$on("resetFilters", () => {
      _this.resetFilters(Math.random());
    });
    setTimeout(function() {
      _this.key = _this.key + 1;
    }, 3000);
    //eventi legati a cordova, partono solo al deviceready che viene scatenato da cordova quanto la app è pronta
    document.addEventListener(
      "deviceready",
      () => {
        setTimeout(function() {
          if (window.innerWidth < 600) {
            screen.orientation.lock("portrait");
          }
        }, 1500);

        //save last start time
        _this.updateLastStartTime();

        document.addEventListener("resume", _this.onResume, false);

        //TODO: cambiare gestione da config.js alla router clicked
        window.IonicDeeplink.route(
          global.config.deeplinks,
          function(match) {
            if (match.$link.url.indexOf("/p/volantini") > -1) {
              _this.$router.push({
                path: match.$route,
                query: match.$args
              });
            } else {
              _this.resolveRoute(match.$link);
            }
          },
          function(nomatch) {
            console.log("NOMATCH :::: ", nomatch);
            _this.resolveRoute(nomatch.$link);
          }
        );

        //con x secondi controllo se c'è una versione più recente
        this.checkVersion();

        this.isPlatformIos();

        if (this.isCordova) {
          window.open = window.cordova.InAppBrowser.open;
        }

        this.onAppTrackingTransparency();

        // Plugin Keyboard
        window.addEventListener("keyboardDidHide", () => {
          // Describe your logic which will be run each time keyboard is closed.
          console.log("keyboardDidHide");
          _this.keyboardOpen = false;
        });
        window.addEventListener("keyboardDidShow", event => {
          // Describe your logic which will be run each time when keyboard is about to be shown.
          console.log(event.keyboardHeight);
          console.log("keyboardDidShow");
          _this.keyboardOpen = true;
        });
        window.addEventListener("keyboardWillShow", event => {
          // Describe your logic which will be run each time when keyboard is about to be shown.
          console.log(event.keyboardHeight);
          console.log("keyboardWillShow");
          //iOS fix
          _this.keyboardOpen = true;
        });
        window.addEventListener("keyboardWillHide", () => {
          // Describe your logic which will be run each time when keyboard is about to be closed.
          console.log("keyboardWillHide");
          //iOS fix

          _this.keyboardOpen = false;
        });
        window.addEventListener(
          "CookiebotOnAccept",
          function() {
            _this.attValue = true;
          },
          false
        );
        window.addEventListener(
          "CookiebotOnDecline",
          function() {
            console.log("CookiebotOnDecline");
            _this.attValue = false;
          },
          false
        );
        window.addEventListener(
          "CookiebotOnDialogDisplay",
          function() {
            console.log("Calling CookiebotOnDialogDisplay");
            // eslint-disable-next-line no-undef
            var hasResponded = Cookiebot.consented || Cookiebot.declined;
            if (
              window.cordova &&
              window.cordova.platformId.toLowerCase() == "ios" &&
              window.plugins.impacTracking &&
              !_this.attResponse
            ) {
              if (_this.attValue) {
                console.log("Ho cliccato su consenti");
                // Ho cliccato su "Consenti"
                // eslint-disable-next-line no-undef
                var stats = Cookiebot.consent.statistics;
                // eslint-disable-next-line no-undef
                var mrkg = Cookiebot.consent.marketing;
                // eslint-disable-next-line no-undef
                var pref = Cookiebot.consent.preferences;
                if (!hasResponded) {
                  console.log("Not responded");
                  // eslint-disable-next-line no-undef
                  Cookiebot.submitCustomConsent(true, true, true);
                  _this.attResponse = true;
                  // eslint-disable-next-line no-undef
                  Cookiebot.hide();
                } else {
                  console.log("Has responded");
                  // eslint-disable-next-line no-undef
                  Cookiebot.submitCustomConsent(pref, stats, mrkg);
                  _this.attResponse = true;
                }
              } else {
                console.log("Ho cliccato su non consentire");
                //Ho cliccato su "non consentire"
                // eslint-disable-next-line no-undef
                var declined = Cookiebot.declined;
                // eslint-disable-next-line no-undef
                Cookiebot.withdraw();
                _this.attResponse = true;
                if (!declined) {
                  console.log("First time");
                  //first time
                  // eslint-disable-next-line no-undef
                  Cookiebot.hide();
                }
              }
            }
          },
          false
        );

        this.refreshLogin();
      },
      false
    );
    if (this.isCordova) {
      //add platfrm to body element
      let platform = window.cordova.platformId;
      document.body.classList.add(platform);
    } else {
      //add platfrm to body element
      let platform = navigator.userAgentData
        ? navigator.userAgentData.platform
        : navigator.platform;
      document.body.classList.add(platform);
      this.checkOsx();
    }
  },
  mounted() {
    // Avoid loading Cookiebot if the page is server rendered (Prerender.io)
    // DOC: Prerender.io crawler User-Agent will always contain: "Prerender (+https://github.com/prerender/prerender)" - src:   https://docs.prerender.io/docs/33-overview-of-prerender-crawlers
    if (!navigator.userAgent.match("Prerender|GTmetrix|Googlebot")) {
      let cookiebotScript = document.createElement("script");
      cookiebotScript.setAttribute("id", "Cookiebot");
      cookiebotScript.setAttribute(
        "src",
        "https://consent.cookiebot.com/uc.js"
      );
      cookiebotScript.setAttribute(
        "data-cbid",
        process.env.VUE_APP_COOKIEBOT_CBID
      );
      cookiebotScript.setAttribute("type", "text/javascript");
      cookiebotScript.async = true;
      document.head.appendChild(cookiebotScript);
    }
  },
  beforeDestroy() {
    global.EventBus.$off("isNotLoggedIn");
    global.EventBus.$off("restart");
    global.EventBus.$off("resetFilters");
  }
};
</script>
